import type { InputTextBoxProps } from '..'
import { isTouchScreen } from '../../../styles'
import type { Tokens } from '../../../theming/types'

export default (config: {
  props: Pick<InputTextBoxProps, 'size' | 'startElement'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    default: {
      wrapper: {
        borderRadius: tokens.radiusSizeXS,
        maxHeight: props.size === 'small' ? tokens.ctaSizeSm : tokens.ctaSizeMd,

        [isTouchScreen]: {
          maxHeight: tokens.ctaSizeLg,
        },
      },

      input: {
        paddingBlockEnd: tokens.spacingGap100,
        paddingBlockStart: tokens.spacingGap100,
        paddingInlineEnd: tokens.spacingGap200,
        paddingInlineStart: props.startElement ? 0 : tokens.spacingGap200,

        [isTouchScreen]: {
          minHeight: tokens.ctaSizeLg,
        },
      },
    },
  } as const
}
